import Geocode from 'react-geocode'
import { getGoogleApiKey } from 'constants/API'

export async function lookupPlaceFromAddress(address: string) {
  try {
    // The API key was historically set as a side effect of mounting AddressMap (Address step). The
    // Propstack embed skips that step entirely, so a pure /embed/* session would geocode key-less
    // and every lookup would fail — set it here, where the request is actually made (idempotent,
    // same key AddressMap sets). Inside the function, not at module load: getGoogleApiKey() throws
    // when the env var is missing, and QA-209 deliberately keeps that throw at the use site.
    Geocode.setApiKey(getGoogleApiKey())
    const response = await Geocode.fromAddress(address)
    if (response.results.length === 0) return null
    return response.results[0]
  } catch (error) {
    console.error(error)
    return null
  }
}
